module.exports = __webpack_public_path__ + "static/media/face7.c996f7f0.jpg";